import { ActionControllerEventName, TextComponent, WindowComponent } from '@verybigthings/vbt-webvr-framework';
import { Box3, Color, DoubleSide, Mesh, MeshBasicMaterial, PlaneGeometry, Vector3 } from 'three';
import { InputManager } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/InputManager';
// import {InputManager} from './InputManager';
export class Input extends WindowComponent {
    constructor(options, type = 'default', maskFunc, wordList) {
        super(options);
        this.inputString = '';
        this.wordList = [];
        this.numbMaxVisibleLetters = 0;
        this._isFocused = false;
        this.options = options;
        this.type = type;
        this.maskFunc = maskFunc;
        this.wordList = wordList;
        if (this.options.maxLength === undefined)
            this.options.maxLength = 9999999;
        this.cursor = new Mesh(new PlaneGeometry(0.05, options.size.y / 1.3, 2), new MeshBasicMaterial({ color: 0x333333, side: DoubleSide }));
        this.cursor.position.z += 0.08;
        this.cursor.visible = false;
        this.addObject(this.cursor);
        this.textTest = new TextComponent(this.getOptions('', options.size.multiplyScalar(0.97), options.pxSize));
        this.addObject(this.text = new TextComponent(this.getOptions('', options.size.multiplyScalar(0.97), options.pxSize)));
        this.maxInputWidth = options.size.x;
        const textSize = new Box3().setFromObject(this.text.uiObject).getSize(new Vector3());
        this.textTest.uiObject.position.x += -this.options.size.x / 2 + textSize.x / 2;
        this.textTest.uiObject.position.y += 5;
        this.textTest.uiObject.position.z = 0.01;
        this.updateTextPos();
        this.initEvents();
        if (this.maskFunc) {
            this.text.setText(this.maskFunc(this.inputString, ''));
            this.updateTextPos();
        }
    }
    get isFocused() {
        return this._isFocused;
    }
    set isFocused(isFocused) {
        this._isFocused = isFocused;
        if (this.blinkInterval)
            clearInterval(this.blinkInterval);
        if (isFocused)
            this.enableBlink();
        else
            this.cursor.visible = false;
    }
    getText() {
        return this.inputString;
    }
    addSymbol(symbol) {
        if (this.inputString.length >= this.options.maxLength && symbol !== '')
            return;
        if (this.inputString.length !== 0 && this.type === 'word' && symbol !== '')
            symbol = ' ' + symbol;
        this.inputString += symbol;
        if (!this.maskFunc) {
            this.calcTestTextPos(symbol);
            this.text.setText(this.inputString.substr(-this.numbMaxVisibleLetters));
        }
        else {
            this.text.setText(this.maskFunc(this.inputString, symbol));
        }
        this.updateTextPos();
    }
    deleteSymbol() {
        if (this.type === 'word') {
            let lastIndexOf = (this.inputString.lastIndexOf(' ') > 0) ? this.inputString.lastIndexOf(' ') : 0;
            this.inputString = this.inputString.slice(0, lastIndexOf);
            this.addSymbol('');
        }
        else {
            this.inputString = this.inputString.slice(0, -1);
            this.addSymbol('');
        }
    }
    setEnter() {
        this.fire('entered');
    }
    clear() {
        this.inputString = '';
        this.calcTestTextPos('');
        this.text.setText('');
        this.updateTextPos();
    }
    initEvents() {
        this.actionController.on(ActionControllerEventName.click, this.uiObject, (event) => {
            if (event.orderNumber !== 0)
                return;
            this.cursor.visible = true;
            this.isFocused = true;
            if (this.blinkInterval)
                clearInterval(this.blinkInterval);
            this.enableBlink();
            this.fire('onInputClicked');
            // @ts-ignore
            InputManager.setInput(this);
        });
    }
    enableBlink() {
        this.blinkInterval = setInterval(() => {
            this.cursor.visible = !this.cursor.visible;
        }, 800);
    }
    getOptions(symbol = '', size, pxSize) {
        const options = {
            background: {
                color: new Color(this.options.background).getStyle(),
            },
            size: size ? size.clone() : this.text.options.size.clone(),
            pxSize: pxSize ? pxSize.clone() : this.text.options.pxSize.clone(),
            text: this.options.text,
        };
        // options.text.lineHeight = 20;
        return options;
    }
    calcTestTextPos(symbol) {
        this.numbMaxVisibleLetters = 0;
        for (let i = this.inputString.length - 1; i >= 0; i--) {
            this.numbMaxVisibleLetters++;
            this.textTest.setText(this.inputString.substr(-this.numbMaxVisibleLetters));
            const b3 = new Box3();
            b3.setFromObject(this.textTest.uiObject);
            const textSize = new Vector3();
            b3.getSize(textSize);
            if (textSize.x >= this.maxInputWidth) {
                this.numbMaxVisibleLetters--;
                break;
            }
        }
    }
    updateTextPos() {
        const b3 = new Box3();
        b3.setFromObject(this.text.uiObject);
        const textSize = b3.getSize(new Vector3());
        this.text.uiObject.position.x = -this.maxInputWidth / 2 + textSize.x / 2;
        this.text.uiObject.position.z = 0.01;
        this.text.uiObject.rotation.set(0, 0, 0);
        this.cursor.position.x = -this.maxInputWidth / 2 + textSize.x;
    }
}
